import { connect } from 'react-redux'
import { actions } from '../../store/submittedForms'
import { generateListCallbacks } from '../../store/helpers/listActionsHelpers'

function mapStateToProps(state) {
  return {
    submittedForms: state.submittedForms,
    submittedFormDetail: state.submittedForms.submittedFormDetail,
    submittedFormReplies: state.submittedForms.submittedFormReplies,
    repliesPending: state.submittedForms.repliesPending,
    users: state.submittedForms.users,
    filters: state.submittedForms.filters,
    authUser: state.auth,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    ...generateListCallbacks(dispatch, actions),
    fetchList: () => dispatch(actions.fetchList()),
    getReplies: params => dispatch(actions.getReplies(params)),
    createReply: params => dispatch(actions.createReply(params)),
    assignUser: params => dispatch(actions.assignUser(params)),
    getStaffUsers: () => dispatch(actions.getStaffUsers()),
    downloadFormPdf: params => dispatch(actions.downloadFormPdf(params)),
    assignFormToStaff: params => dispatch(actions.assignFormToStaff(params)),
    updateFormAdminStatus: params => dispatch(actions.updateFormAdminStatus(params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)